import { render, staticRenderFns } from "./RequestNoVISTypeBanner.vue?vue&type=template&id=ff45fb08&"
import script from "./RequestNoVISTypeBanner.vue?vue&type=script&lang=js&"
export * from "./RequestNoVISTypeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBanner,QItem,QItemSection,QIcon} from 'quasar'
component.options.components = Object.assign({QBanner,QItem,QItemSection,QIcon}, component.options.components || {})
